import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { campaignProgressStatusesDataSource } from 'infrastructure/data-sources/campaign-statuses';

import type { ICampaignProgressStatusItem } from 'infrastructure/data-sources/campaign-statuses';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';

type Options = IBaseSelectBoxOption<
  ICampaignProgressStatusItem['id'],
  ICampaignProgressStatusItem
>[];

interface IProps extends Omit<IBaseSelectBoxProps, 'options'> {
  withAll?: boolean;
}

const CampaignStatusSelectBoxSelectBox: React.FC<IProps> = (props) => {
  const { withAll, ...args } = props;
  const dataSource = useMemo(
    () => campaignProgressStatusesDataSource(withAll),
    [withAll],
  );

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...args} />;
};

export default CampaignStatusSelectBoxSelectBox;
